import { useApiClientStore } from '../stores/useApiClientStore';

import { ApiResponseRaw, ApiResult } from '../types';
import { RepeatMedicationRequestMedicationsResponse } from '../types/repeat-prescription-request';

export async function submitRepeatPrescriptionRequestApi(payload: {
  prescriptionIds: string[];
}): Promise<ApiResult> {
  const api = useApiClientStore().getClient();
  return api.postRaw<ApiResult>('/patient-portal/repeat-medication-request/medications', payload);
}

export async function fetchRepeatPrescriptionRequestApi(): Promise<
  ApiResponseRaw<RepeatMedicationRequestMedicationsResponse>
> {
  const api = useApiClientStore().getClient();
  return api.getRaw<RepeatMedicationRequestMedicationsResponse>(
    '/patient-portal/repeat-medication-request/medications',
  );
}
